import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { getRolePermissions } from '@/utils/rolePermissions';

type AuthenticatedUser = ReturnType<typeof useAuth>;

export const useRolePermissions = <
  TUser extends AuthenticatedUser = AuthenticatedUser,
>() => {
  const user = useAuth() as TUser;

  return useMemo(
    () => ({ user, ...getRolePermissions(user) }),
    [user],
  );
};
